import { INPUT_ADDRESS_MAXIMUM, INPUT_MAXIMUM, INPUT_MINIMUM } from "constants/globalConstants";
export const HEADER_STRINGS = {
  lastUpdate: "Last updated on ",
  desaliTec: "DesaliTec ",
  soarSmart: "CCRO Smart",
  activeAlarms: "Active Alarms",
  home: "Home",
  smartInsights: "Smart Insights",
  sort: "Sort By Time"
};

export const userProfileStrings = {
  userProfile: "Profile & Security",
  organization: "Organization",
  emailID: "Email ID",
  accountSetting: "Account Settings",
  accountPreferences: "Account Preferences",
  accountPreferencesMessage: "Set your preferences regarding the DesaliTec CCRO Smart and click Save to commit your changes.",
  updateMobile: "Update Mobile",
  adminSettings: "Admin Settings",
  help: "Help",
  notificationSetting: "Notification Settings",
  mobileNumberText: "(This mobile number will receive OTP next time at login.)",
  addUser: "Add User",
  manageUsers: "Manage Users",
  systems: "Manage Systems",
  userGuide: "User Guide",
  logout: "Logout",
  administrator: "Administrator",
  tier1: "Tier1",
  tier2: "Tier2",
  access: "Access: ",
  admin: "Admin",
  profile: "Profile",
  userName: "Name",
  userNameMessage: "Note: User Name Should contain atleast 5 and maximum 20 characters",
  userNameError: "Username must be 5-15 characters",
  email: "New Email Address",
  reset: "Reset",
  save: "Save Changes",
  invalidEmail: "Enter valid user id",
  emailExist: "Email id already exists",
  invalidUserName: "Enter valid user name",
  userNameLength: `Name should have ${INPUT_MINIMUM} - ${INPUT_MAXIMUM} characters`,
  takenEmail: "user email already exists",
  security: "Security",
  changePassword: "CHANGE YOUR PASSWORD HERE",
  newPassword: "New Password*",
  confirmPassword: "Confirm Password*",
  newPasswordPlaceholder: "Enter New Password",
  confirmPasswordPlaceholder: "Re-enter New Password",
  passwordMissmatch: "Passwords does not match",
  resetPassword: "Reset Password",
  twofactor: "Two-factor Authentication",
  verifyMessage: "Please enter below the verification code sent to your email in order to reset your password. Kindly check the junk folder",
  resendVerificationCode: "Resend Code",
  resendVerificationCodeMessage: "Didn't recieve the code ",
  accountSettingMessage:
    "Set or update your mobile number here, and click save to commit your changes. Alternatively, you can contact us at support.ccrosmart@dupont.com",
  deletePhoneTitle: "You will be logged out! \n Are you sure you want to proceed?",
  deletePhoneSubTitle: `Please note that proceeding here will log you out of CCRO Smart. To update your mobile number in CCRO Smart: \n\u2022  Enter a mobile number in the prompt presented after login. \n\u2022  The mobile number will receive an OTP for 2-step verification.\n\u2022  Enter OTP. \n\u2022  After successful login, CCRO Smart updates your mobile number.`,
  language: "Language",
  units: "Units",
  country: "System Location",
  users: "Users",
  deleteUser: "Are you sure you want to delete the user, [%], from all the systems?",
  deleteUserWarning: "The selected user will no longer have access to the CCRO Data associated with the systems. This action is irreversible.",
  confirmDelete: "Delete user [Insert Name] from receiving notifications from all the systems",
  editUser: "Edit User Details",
  editUserMessage: "Edit user's details and access for select systems.",
  emailid: "Email ID",
  selectedSystems: "Selected Systems",
  role: "Role",
  status: "Status",
  addaUser: "Add A User",
  addUserMessage: "Enter below values to add a user to DesaliTec CCRO Smart. New users will get access to the selected systems.",
  usercreate: "Email may be in the junkmail folder",
  addSystem: "Add, delete or edit a system here.",
  deleteSystem: "Are you sure you want to delete the system, [%]?",
  deleteSystemWarning: "This action is irreversible and will delete all data associated with this system.",
  confirmDeleteSystem: "Delete system from receiving notifications ",
  addaSystem: "Add a System",
  addaSystemMessage: "Enter below values to add a System to the list.",
  editsystem: "Edit a System",
  editaSystemMessage: "Enter below values to edit a System to the list.",
  addSystembtn: "Add System",
  addReceiverButtonText: "Add Receiver",
  systemid: "System ID",
  systemName: "System Name",
  size: "Size",
  us: "US",
  designFlow: "Design Flow(%)",
  preTreatment: "Pre-Treatment",
  postTreatment: "Post-Treatment",
  max: "Max",
  enabled: "Enabled",
  address: "Address",
  metadata: "Metadata",
  metadataNote: "Note: Only csv ﬁles. 5MB max ﬁle size.",
  uniqueSystemId: "System id should be unique",
  invalidSystemId: "Enter valid system id",
  uniqueSystemName: "System name should be unique",
  invalidSystemName: "Enter valid system name",
  invalidFileformat: "Must be a csv file",
  invalidFileSize: "Must be less than 5 MB",
  addIotbtn: "Add Iot Devices",
  addIot: "Add, delete or edit a device here.",
  deleteDevice: "Are you sure you want to delete the IoT Device, [%]?",
  deleteDeviceWarning: "This action is irreversible and will delete all data associated with this device.",
  addaDevice: "Add a Device",
  addaDeviceMessage: "Enter below values to add a Device to the list.",
  deviceid: "Device ID",
  invalidDeviceId: "Enter valid device id",
  uniqueDeviceId: "Device id should be unique",
  userdetail: " Add, delete or edit user's access here.",
  notificationSettingDescription:
    "Set your and other receiver’s preference for system related alerts for connection status, alarms, reports and insights. You can’t change settings for standard users or other admins with access to CCRO Systems.",
  notificationSettingDescriptionForStandardUser:
    "Set your preference for system related alerts for connection status, alarms and reports. Contact your system’s admin to add email and mobile of a notification receiver.",
  deleteTitle: "Are you sure you want to delete user [name] for the system [systemName]?",
  notificationDeleteDescription:
    "The selected user will stop receiving all the notifications on email and mobile. Note that this won't remove their access to the system.",
  addNotificationTitle: "Add A Receiver To Notify",
  addNotificationSubTitle:
    " Admins can add anyone to receive notifications via email or SMS. Please provide below, email ID and mobile number of the alerts receiver.",
  addNotificationEmailPlaceHolder: "Enter receiver’s email ID",
  addNotificationMobilePlaceHolder: "Enter Mobile Number",
  addNotificationMobile: "Mobile Number",
  prefixCountryCode: "Prefix Country Code",
  disconnectionDuration: "Disconnection duration prior to system status alert",
  alertType: "Alert Types",
  alarmAlert: "Alarms Alerts",
  reportAlert: "Reports Alerts",
  systemAlert: "System Status Alerts",
  deleteAllConfirmation: "Delete receiver [name] from receiving notifications from all the systems",
  internalUser: "Internal",
  externalUser: "External",
  active: "Active",
  inactive: "Inactive",
  userIconTooltip: "Profile & Settings",
  connectionState: "Connection State",
  headerBackBtnTooltip: "Back",
  systemIdPlaceholder: "Example: TAG0001",
  systemNamePlaceholder: "Example: Dupont San Jose",
  noFile: "No file chosen",
  branding: "DesaliTec CCRO Smart - A DuPont Product",
  appVersion: "Version %",
  removeAll: "Remove All",
  ssoId: "SSO ID",
  invalidSSOid: "Enter valid SSO id",
  ssoidExist: "SSO Id already exists",
  ssoidLength: "SSO Id should be 18 characters",
  systemIdLength: `System id should contain ${INPUT_MINIMUM} - ${INPUT_MAXIMUM} characters`,
  systemNameLength: `System name should contain  ${INPUT_MINIMUM} - ${INPUT_MAXIMUM} characters`,
  cit3Average: "CIT3 Average Threshold",
  addDefaultBaselineTitle: "Do you want to Add a Default Baseline ?"
};

export const SYSTEM_TABLE_COLUMNS = {
  sysId: "System ID",
  systemName: "System Name",
  systemUnits: "Units",
  size: "Size",
  designFlow: "Design Flow",
  preTreatment: "Pre-Treatment",
  postTreatment: "Post-Treatment",
  address: "Address",
  systemLocation: "System Location",
  max: "Max",
  enabled: "Enabled",
  metadata: "Metadata",
  viewSystem: "You are viewing system data",
  cit3Average: "CIT3 Average Threshold"
};

export const SYSTEM_UNITS = {
  US: "gpm", // keep this at first place as it is default value
  SI: "m3/h"
};

export const NOTIFICATION_STRINGS = {
  info: "Information Notification",
  warning: "Warning Notification",
  error: "Error Notification",
  success: "Success Notification",
  success_message: "Congratulations! The API has responded with a success message. "
};

export const USERS_TABLE_STRINGS = {
  emailID: "Email ID",
  userName: "Name",
  userSystems: "Systems",
  userRole: "Role",
  userStatus: "Status",
  userLastLogin: "Last Login",
  userStatusActive: "Active",
  userStatusInactive: "Inactive",
  viewUser: `You are viewing user's data`
};

export const NOTIFICATION_TABLE_COLUMNS = {
  systemID: "System ID",
  emailIDs: "Email ID",
  mobileNo: "Mobile No.",
  userType: "User Type",
  statusAlert: "Status Alerts",
  duration: "Duration",
  disconnectedHeaderTootlip: "Disconnection duration prior to system status alert",
  alarmsAlert: "Alarms Alerts",
  reportsAlert: "Reports Alerts",
  viewNotification: "You are viewing notification data",
  insightsAlert: "Insights Alerts"
};

export const primaryMenuString = {
  dashboard: "Dashboard",
  charts: "Charts",
  alarms: "Alarms",
  tags: "Tags",
  reports: "Reports",
  analytics: "Analytics",
  documentation: "Documentation",
  baseline: "Baseline",
  smartInsights: "Smart Insights"
};

export const valueStrings = {
  currentVal: "Current Value",
  close: "Close",
  confirm: "Confirm",
  save: "Save",
  add: "Add",
  cancel: "Cancel",
  apply: "Apply",
  yesDelete: "Yes, Delete",
  verify: "Verify",
  success: "Success",
  delete: "Delete",
  ok: "Ok",
  serverError: "server error, try again later",
  mandatoryField: "* Required Field",
  edit: "Edit",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  search: "Search",
  yes: "Yes",
  no: "No",
  gaugeValueError: "The current value is beyond LL or HH Limits.",
  gaugeValueErrorForOffline: "The current value is beyond LL or HH Limits or the data is not reported as the System is offline.",
  reason: "Reason",
  optional: "Optional",
  clone: "Clone",
  type: "Type here",
  chooseOptionStr: "Choose an option",
  noSystemStr: "No systems selected",
  or: "OR",
  addFile: "Add File",
  here: "here",
  menu: "Menu",
  trend: "Trend",
  zoom: "Zoom",
  update: "Update",
  filter: "Filter",
  noData: "No data found",
  utcFormat: "UTC",
  dash: "-",
  startDate: "Start Date* (DD MMM YYYY)",
  endDate: "End Date* (DD MMM YYYY) ",
  startTime: "Start Time* (HH:mm:ss)",
  endTime: "End Time* (HH:mm:ss)",
  invalidDate: "Invalid Time",
  defaultUnit: "N/A",
  timeFormat: "HH:mm:ss",
  and: "And",
  dateFormat: "DD MMM YYYY",
  date: "Date* (DD MMM YYYY)",
  time: "Time",
  timeWithFormat: "Time* (HH:mm:ss)",
  dateNote: `Note: You can only select upto MAX_MONTHS months of custom time span.`,
  zero: "0"
};
export const dialogStrings = {
  confirm: "CONFIRM",
  cancel: "CANCEL",
  setAsDefault: "SETASDEFAULT",
  add: "Add"
};

export const dashBoardMenuStrings = {
  dashBoard: "DashBoards",
  dashboardMenuDescription: "Configure system widgets & dashboard settings.",
  addDashBoardDescription: "Create a new system dashboard associated to a user account",
  title: "Title",
  primaryDashboard: "Set As Primary Dashboard"
};

export const NO_ITEMS_STRINGS = {
  NoDataTitle: "No data is available because Widgets are missing on this Layout. To add a Widget:",
  NoDataOption1: "Expand the Secondary Panel from the left by clicking ",
  NoDataOption2: "Hover on the Layout ([%])",
  NoDataOption3_1: "Click ADD WIDGET icon",
  NoDataOption3_2: "and select your preferred visualization to start exploring [%] features",
  NoDataOption4: "Finally, fill in the details and click ADD",
  NoLayoutAvailable: "No data is available because layout is missing . To add a Layout:"
};

export const LAYOUTS_NO_ITEMS_STRINGS = {
  noLayoutsTitle: "No layout is available on this System. To add a new layout",
  noLayoutsOption1: "Click ADD LAYOUT icon",
  noLayoutsOption2: "Fill in the details and click Save button"
};

export const LAYOUT_STRINGS = {
  user: "User",
  add: "Add",
  back: "Back",
  system: "System",
  download: "Download",
  edit: "Edit Widget",
  delete: "Delete Widget",
  layoutName: "[%] name",
  layoutTitle: "[%] Title",
  deleteLayout: "Delete [%]",
  primaryLayout: "Primary [%]",
  addLayoutModalTitle: "Add [%]",
  editLayoutModalTitle: "Edit [%]",
  setAsPrimary: "Set as Primary [%]",
  copyLayout: "Copy [%] (optional)",
  editLayoutDesc: "Configure [%] settings",
  nonUniqueLayoutName: "Layout name must be unique",
  addLayoutDesc: "Create a new system [%] associated to a user account",
  defaultDashboardDesc: "Standard Layouts cannot be deleted",
  layoutInfo:
    "Note that users can have only one Primary Layout associated with their account. Primary Layout is always the first to load when users jump into the CCRO Smart pages. To change the Primary Layout, click the Edit Layout button next to the desired Layout and select the ‘Set as Primary’ button. Click Save to set your new Layout as primary.",
  copyLayoutInfo:
    "Please note that one can't copy the Layouts from different systems with Normalized Tags because Normalized Tags need system-specific Baseline and filter criteria. Such Layouts are not present in the dropdown above.",
  titleLength: `Title should contain ${INPUT_MINIMUM} - ${INPUT_MAXIMUM} characters`,
  copyNormChartInfo:
    "Please note that one can now copy Charts with Normalized Tags, indicated by (N) at the end. When copying, you will be prompted to select a system-specific Baseline for the Chart, and the Normalization filters will be copied and applied directly."
};

export const DELETE_DIALOG_STRINGS = {
  delete: "Are you sure you want to delete [%],",
  action: "This action is irreversible.",
  actionNo: "No",
  actionYes: "Yes"
};

export const addTagDataStrings = {
  addTag: "Add Tag Data",
  selectTagDescription: "Select a tag to add widget to the dashboard",
  selectTag: "Select Tag*"
};

export const GaugeWidgetFormStrings = {
  addTitle: "Add Gauge",
  editTitle: "Edit Gauge",
  dashboardDescription: "Select a tag, gauge type and thresholds to add Gauge widget to the dashboard",
  reportDescription: "Select a tag, gauge type and thresholds to add Gauge to the report.",
  selectTag: "Select Tag",
  gaugeType: "Select Gauge Type",
  value: "Value",
  low_low: "LL",
  low: "L",
  high: "H",
  high_high: "HH",
  lowestValue: "Must be the lowest value",
  secondLowest: "Must be the second lowest value",
  secondHighest: "Must be the second highest value",
  highestValue: "Must be the highest value",
  lowerValues: "Lower values are good",
  middleValue: "Middle values are good",
  higherValue: "Higher values are good"
};

export const TimeSeriesWidgetFormStrings = {
  addTitle: "Add Time Series",
  editTitle: "Edit Time Series",
  dashboardDescription: "Select a tag and date range to add time series widget to the dashboard.",
  reportDescription: "Select at least one tag and up to three tags to add time series to the report.",
  dateRange: "Select Date Range",
  past1Month: "Past 1 month",
  past3Months: "Past 3 months",
  past6Months: "Past 6 months",
  past: "Past ",
  month: "Month ",
  noData: "No data available for current date selection",
  noDataFound: "No data found."
};

export const BarchartWidgetFormStrings = {
  addTitle: "Add Bar Chart",
  editTitle: "Edit Bar Chart",
  description: "Select at least one tag and up to three tags and level type to add bar chart to the report.",
  levelType: "Level Type",
  min: "Min",
  max: "Max",
  sum: "Sum",
  mean: "Mean"
};

export const NormalizedWidgetFormStrings = {
  addTitle: "Add Normalized ",
  editTitle: "Edit Normalized ",
  tag: "Tag",
  series: "Series",
  descriptionReport: "Select a tag, thresholds and baseline to add normalized series to the report.",
  descriptionChartAdd: "Select a tag, thresholds and baseline to add normalized tag to the chart.",
  descriptionChartEdit: "Update thresholds and baseline for the all normalized tags added to the Charts.",
  selectBaseline: "Select Baseline",
  addNewBaseline: "Add a New Baseline",
  filterError: "Low value must be less than High value.",
  filterFetchErr: "Unable to fetch default values for Recovery, Feed flow and Reject conductivity.",
  TAG034: `Recovery (%)`,
  TAG071: `Feed Flow (%)`,
  TAG088: `Reject Conductivity (mS/cm)`, //hardcoding the units as per the discussion with team
  H: "High",
  L: "Low",
  contactSystemAdmin: "Contact system administrator to create a baseline to be used in normalization."
};

export const PredictTagStrings = {
  addTitle: "Add Predict Tag",
  editTitle: "Edit Predict Tag",
  description:
    "Select a model type, prediction time, total accumulative tag for Water Prediction and Anti-Scalant dosing pump tag (J1 Flow) for Chemical Prediction, to add predict tag to the report",
  modelType: "Model Type",
  waterPrediction: "Water Prediction",
  chemicalPrediction: "Chemical Prediction",
  predictionTime: "Select Prediction Time",
  nextDay: "Next Day",
  nextWeek: "Next Week",
  nextMonth: "Next Month"
};

export const FreeTextWidgetStrings = {
  addTitle: "Add Free Text",
  editTitle: "Edit Free Text",
  description: "Add texts and notes to the report.",
  freeText: "Free Text"
};

export const landingPageStrings = {
  search: "Search Systems, Smart Insights and Alarms",
  searchMessageTier1: "Search Systems and Alarms",
  online: " Running Systems",
  offline: " Offline Systems",
  disconnected: " Disconnected Systems",
  alarming: " Alarming Systems",
  idle: " Idle Systems",
  all: " All",
  systems: "Systems",
  alarm: "Active Alarms",
  device: "IoT Devices",
  recovery: "Recovery <br/> Last Cycle (%)",
  production: "Production <br/> (%)",
  conductivity: "Conductivity <br/> (%)",
  smartInsights: "Smart Insights",
  tryAgain: "Something went wrong, please try again later",
  welcomeTo: "Welcome to",
  waterSolutions: "Water Solutions",
  noSystemsAssigned: "You don’t have any Systems assigned to you yet.",
  contactAdmin: "Please contact administrator ",
  noPermission: "You don't have permission to access CCRO Smart application.",
  adminEmail: "support.ccrosmart@dupont.com",
  gridView: "Grid View",
  listView: "List View",
  disclamierText:
    " © %y DuPont. All rights reserved. DuPont™, the DuPont Oval Logo, and all trademarks and service marks denoted with ™, ℠ or ® are owned by affiliates of DuPont de Nemours, Inc. unless otherwise noted.",
  dupontTitle: "Dupont.com",
  privacy: "Privacy",
  legalNotices: "Legal Notices & Terms of Use",
  cookiePreferences: "Cookie Preferences"
};

export const AlarmPageStrings = {
  alarmsNotifications: "Alarms Notifications",
  activeAlarm: "Active Alarms",
  alarmHistory: "Alarms History",
  alarmList: "Alarms List",
  searchHere: "Search here",
  seeAllPastAlarms: "See all the past alarms in one place.",
  editAlarmDescription1: `Edit alarm's name and description as well as select the alarms to include in Reports.`,
  editAlarmDescription2: `Keep note that your notification settings are in sync with your alert preferences for alarms here.`,
  noActiveAlarms: "No active alarms for the system",
  noAlarms: "Real-time alerts for selected system Alarms live here. This section allows you to observe your system remotely from anywhere.",
  noAlarmsDescription: "Currently, there are no active alarms for the selected system.",
  noHistoryAlarm: "No alarms history to show",
  editAlarm: "Edit Alarm",
  editAlarmDescription: "Edit alarm details for [%]",
  addAlarmDescription: "Add alarm details for [%]. <br/> It should be aligned with your system's eWon Configuration",
  alarmModalEndText: "That's all your notifications.",
  alarmModalNoAlarmsHeading: "Alerts for active alarms live here.",
  alarmModalNoAlarms: "Currently there are no active alarms for the systems under your access.",
  markAllRead: "Mark All Read",
  alarmNameError: `Alarm Name should contain ${INPUT_MINIMUM} - ${INPUT_MAXIMUM} characters`,
  addAlarm: "Add an Alarm",
  alarmNameExample: "Ex:- ALARM001",
  alarmDescriptionExample: "Ex:- Transmitter fault",
  theAlarm: " the Alarm"
};
export const InsightsStrings = {
  FIT1: "FIT1",
  FIT2: "FIT2",
  alarmsNotifications: "Alarms Notifications",
  activeInsights: "Active Insights",
  insightsHistory: "Insights History",
  insightsList: "Insights List",
  activeInsightsDescription: `You can read more about Smart Insights `,
  insightSummary:
    "Enjoy superior performance and higher reliability with our new feature - Smart Insights. This cutting-edge AI feature will assist your Engineers to predict faults and anomalies across the system(s) and help you reduce operating expenses, downtime, and inaccurate recovery calculations.",
  insightSummarySecondary:
    " This new predictive maintenance feature of DesaliTec CCRO Smart would enable you to rectify the operational issues in time, improve membrane life, and increase recovery (42% to 98%). To know more,",
  contactAdmin: " contact DuPont Admins.",
  brineFlow: "Brine Flow Meter Anomaly",
  brineTag: "Tag - FIT2",
  brineInsight: "Variation in Brine flow is not in proportionate to Circulation pump’s speed & Module differential pressure.",
  feedFlow: " Feed Flow Meter Anomaly",
  feedTag: "Tag - FIT1",
  feedInsight:
    "Variation in Feed flow is not in proportionate to High Pressure (HP) pump’s speed & Module Inlet pressure or HP pump’s discharge pressure.",
  predictionCycle: "Prediction Cycle: ",
  start: "Cycle Start: ",
  end: "Cycle End: ",
  insight: " Insight",
  insightfeed:
    "Variation in Feed flow is not in proportionate to High Pressure (HP) pump’s speed & Module Inlet pressure or HP pump’s discharge pressure.",
  insightBrine: "Variation in Brine flow is not in proportionate to Circulation pump’s speed & Module differential pressure.",
  recommendation: " Recommendation  ",
  recommendationDescription:
    " We recommend that you run the system in manual mode with stable conditions. If the Flow still fluctuates, then the issue is with the instrument.",
  noInsight: "Notifications for Smart Insights live here.",
  noInsightDescription: "Currently there are no Smart Insight notifications active for the systems under your access.",
  insightListDesc:
    "Select Insights to include in Reports and receive alerts via SMS or email. Keep note that your notification settings are in sync with your alert preferences for Insights. You can read more about Smart Insights",
  insightsHistorydescription: `See all the past Insights in one place `,
  insightsModalEndText: "That's all your insights.",
  smartInsights: "Smart Insights",
  insightsModalNoInsightsHeading: "Smart Insights live here.",
  insightsModalNoInsights: "Currently there are no active insights for the systems under your access.",
  sort: "Sort By Time",
  infoText:
    "This cutting-edge AI feature will assist your Engineers to predict faults and anomalies across the system(s) and help you reduce operating expenses, downtime, and inaccurate recovery calculations. This new predictive maintenance feature would help you; rectify the operational issues in time, improve membrane life, and increase recovery (42% to 98%). To know more,",
  contactText: "contact DuPont Admins",
  noInsightsHeaderText: "Now enjoy superior performance and higher reliability with our new feature - Smart Insights.",
  noInsightsText:
    "This cutting-edge AI feature will assist your Engineers to predict faults across the system(s) and help you reduce operating expenses, downtime, and inaccurate recovery calculations.",
  noInsightsTextSec: "To enjoy longer membrane life, and higher recovery (42% to 98%), contact DuPont Admins.",
  viewHistory: "You are viewing insight history"
};

export const SYSTEMS_TABLE_STRINGS = {
  conductivity: "Conductivity",
  recovery: "Recovery",
  production: "Production",
  connectionStatus: "Connection Status",
  systemStatus: "System Status"
};

export const INSIGHT_TABLE_STRINGS = {
  insightID: "Insight ID",
  tagID: "Tag ID",
  headerAlert: "Alerts",
  headerAddToReport: "Add to Report",
  viewInsight: " You are viewing insight data"
};

export const TagPageStrings = {
  taglist: "Tag List",
  noOfTags: " Tags in the system",
  updateTag: "Change Description and Units",
  editTag: "Edit Tag",
  editTagDescription: "Changes being made for [%] should be aligned <br /> with the System’s EWon configuration.",
  tagId: "Tag ID",
  tagName: "Tag Name",
  tagDescription: "Description",
  tagUnit: "Units",
  customTag: "CUSTOM_",
  addTag: "Add a Tag",
  tagDescriptionExample: "Ex :- Pressure/Volume",
  tagIdExample: "Ex:- TAG001",
  tagNameExample: "Ex:- FIT1/AIT3",
  tagUnitExample: "Ex:- pH/psig/bar",
  theTag: " the Tag"
};

export const Tag_Type_Strings = {
  tagType: "Tag Type",
  alarm: "Alarm",
  setpoints: "Set Points",
  standard: "Standard",
  normalized: "Normalized"
};

export const TAGLIST_TABLE_COLUMNS = {
  tagId: "Tag ID",
  tagName: "Tag Name",
  tagType: "Tag Type",
  description: "Description",
  units: "Units",
  currentValue: "Current Value",
  viewingTag: `You are viewing tag's data`
};

export const ReportStrings = {
  report: "Report",
  reportHistory: "Report History",
  pastReportsAtOnePlace: "One place to view all the reports for all the different layouts auto-generated in the past.",
  noReports: "No Reports generated yet",
  reportsInSystem: "Reports in the System",
  reportNotification: "Report Notification",
  addTagsToReport: "Add Tags to Report",
  trendingData: "Trending Data",
  predictData: "Predict Data",
  backToReport: "Back to Reports",
  addCommentHere: "Add a comment here"
};

export const REPORT_HISTORY_TABLE_STRINGS = {
  reportTitle: "Report Title",
  dateRange: "Date Range",
  dateCreated: "Date Created",
  reportSize: "Size",
  downloadReport: "Download Report"
};

export const DROPDOWN_STRINGS = {
  chooseOptionStr: "Choose an option"
};

export const TAGS_GROUP = {
  N: {
    TagType: "Normalized",
    Group: "Normalized Tags"
  },
  T: {
    TagType: "Standard",
    Group: "Standard Tags"
  },
  S: {
    TagType: "Set Point",
    Group: "Set Points"
  },
  F: {
    TagType: "Formula",
    Group: "Formlule"
  },
  NA: "N/A"
};

export const AddWidgetStrings = {
  title: "Add Widget",
  dashboardDescription: "Select from different widget collections to add to your dashboard layout.",
  reportDescription: "Select from different widget collections to add to your Report layout.",
  calculateStr: "Calculate",
  analyzeStr: "Analyze",
  timeSeriesLabel: "Time Series",
  gaugeLabel: "Gauge",
  tagDataLabel: "Tag Data",
  normalizedSeriesLabel: "Normalized Series",
  predictTagLabel: "Predict Tag",
  barChartLabel: "Bar Chart",
  freeTextLabel: "Free Text"
};

export const DeleteWidgetStrings = {
  title: "Are you sure you want to delete widget, % ?",
  description: "The deleted widget will no longer be part of layout %."
};

export const WidgetStrings = {
  addWidget: "Add Widget",
  addTag: "Add Tag",
  save: "Save",
  editWidget: "Edit Widget",
  widgetTitle: "Widget Title",
  selectTag: "Select Tag",
  levelType: "Level Type",
  titlePlaceholder: "Type a title here",
  typeHere: "Type here",
  systemTag: "SystemTag"
};

export const TagWidgetFormStrings = {
  addTitle: "Add Tag Data",
  editTitle: "Edit Tag Data",
  dashboardDescription: "Select a tag to add widget to the dashboard.",
  reportDescription: "Select a tag and level type to add tag data to the report.",
  min: "Min",
  max: "Max",
  mean: "Mean"
};

export const AutogenerateReportStrings = {
  autoGenerateSettings: "Enable Weekly Report",
  reportGenerationMsg: "You will receive the report on a weekly basis (%)."
};

export const ReportTitleStrings = {
  tags: "Tag ID: ",
  tagName: "Tag Name: ",
  levelType: "Level Type: ",
  modelType: "Model Type: ",
  predictionTime: "Prediction Time: ",
  TAG034: `Recovery (%): `,
  TAG071: `Feed Flow (%): `,
  TAG088: `Reject Conductivity (mS/cm):`, //hardcoding the units as per the discussion with team,
  thresholdBaseline: "Thresholds & Baseline",
  baseline: "Baseline: ",
  baseTrial: "Baseline Trial: ",
  gaugeType: "Gauge Type: ",
  low: "Low",
  high: "High",
  ll: "LL: ",
  l: "L: ",
  hh: "HH: ",
  h: "H: ",
  widgetType: "Widget Type:",
  predctionNote: "Our prediction model is based on past 1 month of historic data, starting from today.",
  Note: "Note: ",
  baselineValuesMessage: "The values depend on the baseline selected and may differ from the values seen on the analytics page"
};

export const ReportGenerateStrings = {
  selectRange: "Select Date Range ",
  day: "Past 1 Day",
  week: "Past 1 Week",
  month: "Past 1 Month",
  custom: "Custom",
  dateError: "!No Date range is selected",
  generateReport: "Generate Report",
  downloadFailed: "Download has failed. Please try after sometime",
  moveWidgets: "**Move the widgets up and down to position them as desired for your reports",
  addAllWidgets: "Add All Widgets to report",
  downloadCSVHeader: "Data for widget :  "
};

export const BaselineStrings = {
  baseline: "Baseline List",
  cloneBaseline: "Clone Baseline",
  addBaseLine: "[%] A Baseline",
  deleteBaseLine: "Delete Baseline",
  baselineMessage: "One place to view all the baselines related to the normalized series added for the system.",
  baselineDelete: "Are you sure you want to delete baseline?",
  baselineDeleteWarning: "This action is irreversible and will delete all data associated with this baseline",
  confirmBaselineDelete: "Delete baseline from the system",
  addBaselineMessage: "Enter below values to add a baseline. The new baseline will be available under Baseline List.",
  duplicateTitle: "Please enter a unique baseline title",
  baselineValueMessage: "(Note: Enter a Timestamp to retrieve tag values for (e.g. last CIP activity timestamp))",
  baselineManualMessage: "(Note: Please enter Baseline Values before adding a new baseline manually.)",
  date: "Date",
  validate: "Validate",
  addNewBaseline: "[%] New Baseline",
  editTag: "Edit Tags",
  saveTag: "Save Tags",
  timestamp: "Timestamp",
  manually: "Manually",
  timeZone: "TimeZone*",
  time: "Time*",
  baseLineTitle: "Baseline Title",
  placeholder: "Type here",
  retrieve: "Retrieve Data",
  nameExist: "Same name already exists",
  titleLength: "Title should contain 5 - 50 characters",
  validationError:
    "Validation wasn’t successful, some values were missing. Change the Timestamp or enter the missing values manually [%]. If changing the timestamp values  Retrieve Data again.",
  enterBelowValue: "Enter below values to add a baseline. Read more",
  baselineReadOnlyMsg: `You are viewing baseline values. Please note that users can’t edit baseline values <br/> because they are used by the systems to normalize the tags. But you can clone a baseline.`,
  baselineId: "Baseline ID:",
  baselineTimestamp: "Timestamp used for Baseline:",
  baselineValue: "Baseline Value:",
  manual: "manual",
  setAsDefaultBaseline: "Make Default"
};

export const InputErrorStrings = {
  required: "Required",
  addressValidationError: `Address should contain max ${INPUT_ADDRESS_MAXIMUM} characters`,
  minimumRequired: `Minimum ${INPUT_MINIMUM} characters Required`,
  maxlimitis: "Max limit is ",
  duplicateTagId: "Tag ID already exists.",
  duplicateAlarmId: "Alarm ID already exists.",
  alarmPrefix: "Alarm ID must start with 'ALARM'",
  maxlimitreached: `Maximum length of ${INPUT_ADDRESS_MAXIMUM} characters reached`
};

export const GaugeStrings = {
  Mean: "Mean",
  Min: "Min",
  Max: "Max"
};

export const ToasterStatusStrings = {
  warning: "Warning",
  error: "Failed",
  success: "Success"
};

export const AppStrConstant = {
  NormalizedWidgetFormStrings,
  FreeTextWidgetStrings,
  WidgetStrings,
  DROPDOWN_STRINGS,
  InputErrorStrings,
  ToasterStatusStrings
};

export const ChartStrings = {
  tagsWithNoData: "Some of the selected tags ([%]) don’t have any data for the selected time.",
  chartNoDataMsg: "No data is available. Kindly do one of the following to generate a trend graph:",
  chartNoDataOption1: "Add at least one Tag from the dropdown above",
  chartNoDataOption2: "Try changing the date range for the selected tags",
  chartNoDataOption3: "For Normalized Tags, try editing the threshold and baseline values from ‘Edit Details’ section above",
  chartDurationMsg: "Tags plotted within [from] to [to]",
  chartTrendLine: "Average Trend Line",
  multiYDisabledWarningMsg:
    "Multi-Y is only available for 5 or less number of selected tags. Delete or unselect some tags to enable multi-Y plot type.",
  addTagsDisabledWarningMsg: `You can add or select up to 15 tags in a single Chart Layout, and Multi-Y is only available for a maximum of 5 selected tags. Delete or unselect some tags to enable the Multi-Y button or 'Add Charts' dropdown.`,
  plotType: "Plot Type",
  dateRange: "Timestamp",
  addChartTags: "Add Tags to Chart",
  editDetails: "Edit Details",
  MULTI_PLOT: "Multi Plot",
  MULTI_Y_PLOT: "Multi-Y",
  SINGLE_PLOT: "Single Plot",
  EDIT_TAGS: "Edit Tags",
  EDIT_ALARMS: "Edit Alarms",
  EDIT_NORMALIZE_FILTERS: "Edit Normalization Filters",
  mobileMultiY: "Cannot display Multi-Y chart on mobile devices",
  save: "Save",
  reset: "Reset",
  cancel: "Cancel",
  layoutText: "Create new layouts and configure chart settings.",
  CREATE_BASELINE: " Carefully pick a point (timestamp) from the highlighted plot-area to create a new Baseline OR",
  ENTER_MANUALLY: "Enter Manually",
  zoominAddTagWarning: `Adding a new tag to the layout resets the chart's zoom to the original state.`,
  turnOnTags: "Nothing to display here because display for all the added Tags are turned off.",
  turnOnTagsStep1: "Kindly open the Edit Tag details and turn ON the display for at least one Tag among the added Tags or",
  turnOnTagsStep2: "Add a new Tag from the dropdown above for the Chart Layout with less than 15 added Tags.",
  baselineValuesMessage: "Note: The values depend on the baseline selected and may differ from the values seen on the analytics page",
  limitsErrorMsg: "Error: Upper limit should be greater than lower limit"
};

export const AnalyticsStrings = {
  analytics: "Analytics",
  noDataMsg: "No data is available. Try changing the date range in timestamp dropdown.",
  layoutName: `CIP (Cleaning-in-place) <br/> Performance Analysis (Default)`,
  layoutText: `Enjoy CIP defaults and smart layout. Easily judge your cleaning performace over time`,
  dateRange: "Timestamp",
  editDetails: "Edit Details",
  EDIT_ALARMS: "Edit Alarms",
  CIP_NOTE: `Note: CIP is indicated at the the end time of the cleaning cycle.`,
  CIP_Overlay: "CIP Overlay Graph",
  CIP_TIME_CLEANING: `CIP Time and Cleaning Indexes`,
  CIP_CLEANING_REQUIRED: `Cleaning Required!`,
  Baseline: "Normalized Baseline",
  VerticalLines: `Vertical lines represent CIPs shut down/flushing dates`,
  Normalized_DP: "For Normalized Differential Pressure",
  Normalized_PF: "For Normalized Permeate Flow",
  Normalized_SP: "For Normalized Salt Passage",
  CIP_Cleaning_Scatter_Chart: "Scatter Chart",
  CIP_Cleaning_Bar_Chart: "Bar Chart",
  CIP_Cleaning_Index_Table: "Index Table",
  CIP_Cleaning_Required: "Cleaning Indicators",
  CIP_Cleaning_Required_Note:
    "Exception has been noted in normalised CIP Variables. These are current operational values of the CIP Variables for past 24hrs.",
  CIP_Cleaning_Required_Values_Note: "Note: The current values are updated every 24 hours",
  cipGreen: "Green: ",
  cipValueDescriptionGreen: "Effective CIP, No action needed",
  cipOrange: "Orange: ",
  cipValueDescriptionYellow: "Borderline Acceptable, Can repeat CIP (optional)",
  cipRed: "Red: ",
  cipValueDescriptionRed: "Poor/ Ineffective CIP, Repeat CIP (mandatory)",
  cipGrey: "Grey: ",
  cipValueDescriptionGrey:
    "Cleaning Index measures the effectiveness of each CIP by calculating the amount of cleaning done as compared to the maximum cleaning possible.",
  cipValueDescriptionNote:
    "Note: 2 consecutive CIPs less than 75% are considered as ineffective cleaning process,	Reconsider each step of cleaning activity: cleaning composition, heating temperature, cleaning solution and so on.	",
  historicMembrane: "Historic Membrane Replacement",
  noHistoricMembrane: "No historic membrane replacement incident observed.",
  trendline: " Trendline",
  trendlineLegend: "Trendline(slope: 0.021 %/day)"
};

export const CIPAnalyticsIndexTableStrings = {
  Id: "CIP ID",
  Start_Time: "CIP Start Time",
  End_Time: "CIP End Time",
  DP_Cleanability_Initial: "DP Cleanability % to Initial",
  PF_Cleanability_Initial: "PF Cleanability % to Initial",
  SP_Cleanability_Initial: "SP Cleanability % to Initial"
};

export const CIPAnalyticsCleaningTableStrings = {
  Tag: "Variable",
  Cleaning_Requirements: "Cleaning Requirements",
  Baseline_Value: "Initial Baseline Values",
  Current_Value: "Current Values",
  Percent_to_Initial: "% to Initial"
};

export const API_STATUS_STRINGS = {
  post: "Item added successfully!!",
  put: "Item updated successfully!!",
  delete: "Item deleted successfully!!",
  unAuthorized: "You are not authorized, redirecting to login screen",
  fail: "Unable to perform the action, Please try again later"
};

export const CHART_PLOTLY_STRINGS = {
  downloadCSV: "Download Excel File",
  refreshData: "Refresh data",
  toggleSpikeLineOff: "Normalized data",
  toggleSpikeLineOn: "Smoothened data"
};

export const CHART_DOWNLOAD_DATA_DIALOG_STRINGS = {
  title: `Download Tag's Data`,
  confirmBtn: `Download Excel File`,
  dialogDescription: `Please enter your preferred data point's time intervals with a minimum interval of 10 secs. For example, 2 min time-interval for the past 1 hour downloads 30 tag-data points. The download will begin in the background and might take a few minutes.`,
  intervalLabel: `Data point interval`,
  minimumValMsg: `Minimum value is 10 seconds.`,
  downloadDurationMsg: `Download Tag's Data from [from] to [to]`,
  downloadSuccessful: `Download Successful`,
  downloadSuccessfulMsg: `Please check your Downloads for file [fileName]`,
  downloadFailed: `Download Failed`,
  downloadStarted: `Download Started`,
  downloadStartedMsg: `The download began in the background and might take a few minutes.`,
  downloadFailedMsg: `The Excel file download failed because of heavy data load and delayed system response. Please try increasing the data point's time intervals.`,
  excelNoteCell: `Note: Blank cells, if any, indicate the tag value was unchanged from the previous timestamp.`
};

export const BASELINE_TABLE_STRINGS = {
  baselineID: "Baseline ID",
  baselineTitle: "Baseline Title",
  baselineTimestamp: "Timestamp",
  baselineMode: "Baseline Mode",
  automated: "Automated",
  manual: "Manual",
  auto: "auto",
  default: "default",
  defaultText: "Manual (Default)"
};

export const CHART_EDIT_TAGS_TABLE_STRINGS = {
  editTags: "Edit Tag Details",
  tagString: "Tag",
  tagsAdded: "[%] Tags Added",
  headerDisplay: "Show Data",
  headerTrendline: "Show Avg.",
  headerTranlineDesc:
    "This trend line displays the average value of the tags plotted over the selected timestamp. It is displayed in black color. Users can select the checkbox to display them in the Chart. Please note that these will only be visible in Multiplot or in Single-Plot with only one Tag.",
  headerTagID: "Tag ID",
  headerTagName: "Tag Name",
  headerUnit: "Tag Unit",
  headerColor: "Data Color",
  headerType: "Data Plot Type",
  headerPosition: "Position",
  headerBin: "Bin",
  headerDelete: "Delete",
  tagTypeLine: "Line",
  tagTypeScatter: "Scatter",
  tagTypeLineScatter: "Line + Scatter"
};

export const ALARMS_TABLE_STRINGS = {
  alarmsDetails: "Historic Alarms Details",
  headerAlarmDisplay: "Display",
  headerAlarmID: "Alarm ID",
  headerAlarmName: "Alarm Name",
  headerAlarmDesc: "Description",
  headerAlarmTimestamp: "Timestamp",
  headerAlarmAlert: "Alerts",
  headerAlarmAddToReport: "Add to Report",
  viewAlarm: `You are viewing alarm's data`
};

export const Weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const StatusText = {
  disconnected: "Disconnected",
  offline: "Offline",
  online: "Online",
  running: "Running",
  idle: "Idle",
  alarming: "Alarming"
};
export const ConnectionState = ["Enabled", "Disabled"];

export const RefreshKey = {
  userSettingPage: "userSettingPage",
  alarmTabKey: "alarmTabKey",
  insightTabKey: "InsightTabKey",
  systemDeviceTabKey: "systemDeviceTabKey",
  dashboardLayout: "dashboardLayout",
  chartLayout: "chartLayout",
  reportLayout: "reportLayout",
  lastVisitedURL: "lastVisitedURL",
  pageRefreshed: "pageRefreshed"
};
export const INSIGHT_HISTORY_TABLE_STRINGS = {
  systemId: "System ID",
  systemName: "System Name",
  insightName: "Insight Name",
  tagName: "Tag Name",
  insightDescription: "Insight Description",
  recommendation: "Recommendation",
  startTime: "Start Time",
  endTime: "End Time"
};

export const INSIGHT_TIMESERIES = {
  RO1_FIT_1: "RO1_FIT_1_PV",
  FIT_2_PV: "FIT_2_PV (gpm)",
  MEMBRANE_M_DP: "MEMBRANE_M_DP (psid)",
  P3_RPM: "P3_RPM (rpm)",
  RO1_SYSTEM_STATUS: "RO1_SYSTEM_STATUS",
  RO1_P_2_RPM: "RO1_P_2_RPM",
  RO1_PT_1_PV: "RO1_PT_1_PV",
  RO1_FIT_2_PV: "RO1_FIT_2_PV"
};
export const WIDGET_TYPE = {
  gauge: "Gauge",
  timeseries: "Timeseries"
};

export const GenerateReport = {
  ccroReport: "CCRO Report",
  TM: "TM",
  period: "Period:",
  sysId: "System ID:",
  sysName: "System Name:",
  watersolutionLink: "https://www.dupont.com/water",
  comment: "Comment: ",
  noAlarms: `No Active Alarms are available to display here for the time duration selected by you. It is either because the system didn't raise any Alarm for [%d] or you haven't selected any Alarms to include in Reports on the Alarms page of DesaliTec CCRO Smart.`
};

export const BaselineReadPopup = {
  createNewBaseline: "To create a new Baseline:",
  baselineTitle: "Add a Baseline Title (mandatory to create unique baselines).",
  newbaseline:
    "One can create a new baseline by either adding a timestamp value ideal for normalization or manually entering the Tag values against the correct Tag ID.",
  baselineViaTimestamp: "To add a baseline via timestamp, one has to enter the timezone",
  timestampNote: "(Note that this timezone can be different from your system timezone)",
  baselineViaTimestampSecond: ", date, and time in full format. Make sure to select the ’00’ value for seconds and minutes if no other value exists.",
  retriveDataText1: "Once satisfied with timestamp values, click",
  retriveData: "Retrieve Data",
  retriveDataText2: "to validate the entered values of the timestamp. If data is correctly validated, proceed and click the ",
  addNewBaseLine: "Add New Baseline",
  button: "button.",
  retriveDataText3:
    "If validation show errors then, correct the fields highlighted in red or enter a new timestamp. After corrections, Retrieve Data again.",
  addNewBaselineText1:
    "To add a baseline manually, switch the radio button and enter the Tag Values for all the Tag IDs present. Once done, click the ",
  editTags:
    "To correct Tag ID mapping, click the Edit Tags button on the right-hand corner to enable Tag ID dropdowns and select the Tag IDs per your requirement.",
  pressSaveButton: "Before proceeding further, save the new tag mapping by clicking the Save Tags button.",
  saveButtons: "Clicking the",
  saveAndAdd: "Add New Baseline or Save as New buttons",
  closePopup: "will close the pop-up. The new baseline will be available under the Baseline List."
};

export const CIPPrediction = {
  cip: "CIP Prediction",
  predictionInfo:
    "3-parameter model is developed based on the data after cleaning. Then the inverse prediction is used. To know more inspect data in the Analytics page",
  predictionNote: "*A negative value of proposed days indicates abnormal trend in the data.",
  predictionVariable: "System Performance Variable",
  predictionCC: "Remaining CC Cycles",
  predictionCleaning: "Proposed Cleaning",
  currentValue: "Current Value",
  threshold: "User Defined Thresholds",
  predictionCleaningDays: "In % Days",
  foulingType: "Refer Fouling Types",
  inspectfurther: "Inspect further in Analytics",
  dp: "Norm. DP",
  flow: "Norm. Flow",
  Sp: "Norm. SP",
  foulingTypes: "Fouling Types",
  noFouling: "Not enough data to detect fouling for this system",
  predictionWindow:
    "This tool predicts a CIP within up to the next 60 days from now.Any prediction longer than this time will show as greater than 60 days from now.",
  filtered_data: "Below prediction results are obtained based on filtered smoothened data.",
  smoothened_data: "Due to variability in the sensor data below prediction results are obtained based on unfiltered smoothened data."
};

export const FoulingTypes = {
  noFouling: "No Fouling",
  organicFouling: "Organic Fouling",
  bioFouling: "Bio Fouling",
  scalingFouling: "Scaling",
  particulateFouling: "Particulate Fouling",
  colloidalFouling: "Colloidal Fouling",
  mechanicalDamage: "Mechanical Damage",
  integrityFailure: "Integrity Failure",
  integrityMechFailFouling: "",
  increasing: "Increasing",
  rapidlyIncreasing: "Step Increasing",
  decreasing: "Decreasing",
  rapidlyDecreasing: "Step Decreasing",
  notChanging: "Not Changing",
  symptom: "Symptom",
  permeateFlow: "Permeate Flow ",
  saltPassage: "Salt Passage ",
  differentialPressure: "Differential Pressure ",
  directCause: "Direct Cause : ",
  indirectCause: "Indirect Cause : ",
  linear: "Linear ",
  nonLinear: "Non-linear ",
  optional: "*",
  optionalDescription: "Optional parameters to be used on fouling determination"
};

export const INSIGHT_TYPE = {
  insights: "Insights",
  prediction: "Prediction",
  cleaning: "Cleaning",
  membranePrediction: "MembranePrediction"
};

export const FORMATTED_WIDGET_TYPE = {
  Timeseries: "Time Series",
  Tag: "Tag",
  Gauge: "Gauge",
  Normalization: "Normalized Series",
  Prediction: "Predict Tag",
  BarChart: "Bar Chart",
  Text: "Text"
};

export const CIPHistoricMembrane = {
  id: "ID",
  startTime: "Start Time",
  endTime: "End Time"
};
export const MembranePrediction = {
  conductivity: "Permeate Conductivity (µS/cm)",
  pt2: "HPP Discharge Pressure",
  dp: "Differential Pressure",
  conductivityPopovertextAdmin: "Go to Systems, and edit system to change the value of Permeate Conductivity threshold",
  conductivityPopovertext: "Contact CCRO Smart Support to change the value of Permeate Conductivity threshold",
  membranePredictionCleaningDays: "In % Months",
  membranePrediction: "System Performance Advisor",
  thresholdTime: "Time to reach threshold",
  heading: "Projected Time to Exceed Critical Operating Threshold",
  cc: "(CC Cycles)",
  time: "(Months)",
  membranePredictionMethod: "Below results are obtained based on lowess smoothened data",
  membranePredictionNote:
    "This tool considers long-term system performance and projects potential mechanisms that may lead to membrane element end-of-life. When a declining performance trends is detected, potential causes are summarized along with troubleshooting recommendations to enable operator intervention. ",
  mainMessageTitle1: "Performance insights:",
  mainMessageTitle2: "Potential causes:",
  mainMessageTitle3: "Recommended steps:",
  detailedDescription: "Detailed Description:",
  detailedDescriptionMessage: "See Detailed Description here",
  conductivityMainMessageTitle: "Conductivity Insights",
  conductivityMainMessage1: "System average permeate conductivity is projected to exceed the user defined threshold in",
  conductivityMainMessage12: "months. Exceeding this threshold may result in off-spec feed water to downstream processes.",
  conductivityMainMessage2:
    "High solute passage may have different causes, such as leaking O-rings, telescoping, and membrane mechanical damage or membrane chemical damage. Other possible causes could include metal oxide fouling and/or mineral scaling or changes in inlet water quality.",
  conductivityMainMessage3:
    " Verify conductivity measurement calibration. Review system normalized performance data and for signs of element fouling or scaling and CCRO SMART CIP Prediction for fouling type suggestions. Verify ORP data and ORP instrument calibration. Perform vessel profiling and probing. Contact Desalitech technical service.",
  conductivityDetailledDescription1:
    "High solute passage in a reverse osmosis (RO) system may have different causes, such as leaking O-rings, telescoping, and membrane surface abrasion or membrane chemical damage. Leaking O-rings can be detected by the probing technique, and O-rings should be inspected for correct installation and as-new condition. Telescoping is caused by excessive pressure drop from feed to concentrate, and it can be identified by probing and by a leak test. Membrane surface abrasion can be caused by crystalline or sharp-edged metallic particles in the feedwater that scratch the membrane surface. If a system exhibits high solute passage, one of the first steps in troubleshooting is to localize the source. To localize high solute passage in a system, it is first recommended to profile the system. All individual vessel TDS or conductivity or other relevant quality values are checked. If one pressure vessel shows a significantly higher permeate concentration than the other vessels of the same stage, then this vessel should be probed. The procedure allows locating a problem within a pressure vessel while online without unloading elements.",
  conductivityDetailledDescription2:
    "Uniformly high solute passage across all pressure vessels and elements may be an indication of membrane chemical damage. RO/NF membrane have limited tolerance to free chlorine and removing residual free chlorine by pretreatment prior to exposure of the feedwater to the membrane is recommended. The absence of chlorine should be monitored using an oxidation-reduction potential (ORP) electrode downstream of the mixing line. 175 – 200 mV threshold readings of the ORP have been typically applied. The electrode signal shuts down the high-pressure pump when chlorine is detected.",
  conductivityDetailledDescription3:
    "If RO element mechanical or chemical damange is confirmed, replacement of the affected elements may be required.",
  pt2MainMessageTitle: "PT2 Insights",
  pt2MainMessage1: "Cycle end pressure is predicted to meet the system threshold in",
  pt2MainMessage12: "months. This could result in the system being unable to achieve the target permeate flow rate at the target recovery.",
  pt2MainMessage2:
    "Increased feed water TDS, high resistance in element feed channels due to high feed flow rates and/or low operating temperatures. Other possible causes include high permeate backpressure, and RO element fouling or scaling.",
  pt2MainMessage3:
    "Verify instrument calibration, feed water flow rate, inlet water quality and antiscalant dosing rate. Verify that permeate line is not throttled. Inspect cartridge filter and lead and tail RO element scrolls for signs of fouling or scaling. Review CCRO SMART CIP Prediction for fouling type suggestions. Perform clean-in-place to remove foulants from the RO elements. Contact Desalitech technical service. ",
  pt2DetailedDescription1:
    "High feed pressure in a reverse osmosis (RO) system can occur due to various reasons. An excessive pressure drop occurs when the recommended maximum feed flow rates are exceeded, or when the feed pressure builds up too fast during start-up. Water hammer, a hydraulic shock to the membrane element, can also happen when the system is started up before all air has been flushed out. This could be the case at initial start-up or at operational start-ups when the system has been allowed to drain. The feed to concentrate differential pressure is a measure of the resistance to the hydraulic flow of water through the system. It is very dependent on the flow rates through the element flow channels and on the water temperature. t is therefore suggested that the permeate and concentrate flow rates be maintained as constant as possible in order to notice and monitor any element plugging that is causing an increase in differential pressure. Some common causes of element plugging include bypass in cartridge filters, pretreatment breakthrough, pump impeller deterioration, scaling, brine seal issues, biological fouling, and precipitated antiscalants.",
  pt2DetailedDescription2:
    "If RO element plugging exists and cannot be resolved through clean-in-place with appropriate chemicals and procedures, membrane replacement may be required.",
  pt2DetailedDescription3:
    "It is important to note that high feed pressure can cause damage to the membrane elements and the high-pressure pump. Therefore, the pressure vessels, shut-down switches, and valves must be installed and maintained properly to prevent any damage.",
  dpMainMessageTitle: "DP Insights",
  dpMainMessage1: " Membrane differential pressure is projected to increase above the system limits in",
  dpMainMessage12: "months. This could result in mechanical damage to membrane elements and the high-pressure pump.",
  dpMainMessage2:
    "High resistance in element feed channels due to high feed flow rates and/or low operating temperatures. Other causes of high differential pressure include bypass in cartridge filters, pretreatment breakthrough, pump impeller deterioration, scaling, brine seal issues, biological fouling, and precipitated antiscalants.",
  dpMainMessage3:
    "Verify instrument calibration, feed water flow rate, inlet water quality and antiscalant dosing rate. Inspect cartridge filter and lead and tail RO element scrolls for signs of fouling or scaling. Review CCRO SMART CIP Prediction for fouling type suggestions. Perform clean-in-place to remove foulants from the RO elements. Contact Desalitech technical service.",
  dpDetailedDescription1:
    "The feed to concentrate differential pressure is a measure of the resistance to the hydraulic flow of water through the system. It is very dependent on the flow rates through the element flow channels and on the water temperature. It is therefore suggested that the permeate and concentrate flow rates be maintained as constant as possible in order to notice and monitor any element plugging that is causing an increase in differential pressure. The knowledge of the extent and the location of the differential pressure increase provides a valuable tool to identify the cause(s) of a problem.",
  dpDetailedDescription2:
    "High differential pressure can be caused by various factors such as exceeding the recommended maximum feed flow rates, water hammer, biofouling, bypass in cartridge filters, pretreatment media filter breakthrough, pump impeller deterioration, scaling, and brine seal issues.",
  dpDetailedDescription3:
    "It is important to note that high differential pressure can cause damage to the membrane elements and the high-pressure pump. Therefore, it is recommended to monitor the differential pressure regularly and identify the cause(s) of the problem to prevent any damage.",
  dpDetailedDescription4:
    "The upper limit of the differential pressure per multi-element vessel is 50 psi (3.5 bar), per single fiberglassed element 15 psi (1 bar). When these limits are exceeded, even for a very short time, the FilmTec ™ Elements might become telescoped and mechanically damaged. Eight-inch elements will break circumferentially at any location of the fiberglass shell, or the endcap will be pushed out, or the spokes of the endcap will break, or the feedspacer will be pushed out from the concentrate channels. The maximum pressure drop per element is 15 psi (0.9 bar) at temperatures below 50°C and 8 psi (0.5 bar) at temperatures below 70°C. The maximum pressure drop per vessel is 60 psi (4.1 bar) at temperatures below 50°C and 30 psi (2.0 bar) at temperatures below 70°C.",
  dpDetailedDescription5:
    "If RO element plugging exists and cannot be resolved through clean-in-place with appropriate chemicals and procedures, membrane replacement may be required."
};
export const TrendlineStrings = {
  trendlineName: `{Trendline[tagId]} Trendline (slope: {slope} {unit}/day)`,
  normalized_differential_pressure: "Norm. DP",
  normalized_permeate_flow: "Norm. Flow",
  normalized_salt_passage: "Norm. SP"
};
